var exports = {
  "k": "xdde3148b--5a24d5--container",
};

module.exports = exports;
